/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

$(async function () {
	function calculateSizes() {
		const hb = document.querySelector('.header-banner');
		if (hb) {
			document.documentElement.style.setProperty('--hb', `${hb.offsetHeight}px`);
		}
		else {
			document.documentElement.style.setProperty('--hb', `0px`);
		}
	}

	calculateSizes();

	const header = document.querySelector('header');
	const placeholder = document.getElementById('headerPlaceholder');
	const banner = document.querySelector('.header-banner');

	function updateHeader() {
		if (!header || !placeholder || !banner) return;

		const bannerBottom = banner.getBoundingClientRect().bottom;
		const shouldFix = bannerBottom <= 0;

		if (shouldFix) {
			placeholder.style.height = `${header.offsetHeight}px`;
			placeholder.classList.add('is-active');
			header.classList.add('is-fixed');
		} else {
			placeholder.style.height = '0px';
			placeholder.classList.remove('is-active');
			header.classList.remove('is-fixed');
		}
	}

	window.addEventListener('scroll', updateHeader, { passive: true });
	window.addEventListener('resize', updateHeader);

	updateHeader();

	// Wrap buttons
	$('p a.button').each(function () {
		$(this).wrap('<div class="button__wrapper"></div>').append('<span></span>');
	});

	// Responsive table
	$('table').wrap('<div class="table-wrapper">');

	// Google Maps 
	$('.google-maps').each(async function () {
		var maps = $(this);
		var apiKey = maps.data('api-key');
		var dataGeolocation = maps.data('geolocation').split(',');

		const loadGoogleMapsApi = (await import('load-google-maps-api')).default;
		const googleMaps = await loadGoogleMapsApi({
			key: apiKey
		});

		var myLatLng = {
			lat: parseFloat(dataGeolocation[0]),
			lng: parseFloat(dataGeolocation[1])
		};

		var map = new googleMaps.Map(document.querySelector('.google-maps'), {
			center: myLatLng,
			zoom: 13,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: [{ "featureType": "administrative", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "saturation": "-100" }, { "lightness": "57" }] }, { "featureType": "poi", "elementType": "geometry.stroke", "stylers": [{ "lightness": "1" }] }, { "featureType": "poi", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "visibility": "on" }] }, { "featureType": "transit", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "labels.text", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [{ "visibility": "off" }, { "color": "#484848" }] }, { "featureType": "transit", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "labels.icon", "stylers": [{ "visibility": "on" }] }, { "featureType": "transit.station.bus", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "transit.station.bus", "elementType": "labels.text.fill", "stylers": [{ "saturation": "0" }, { "lightness": "0" }, { "gamma": "1.00" }, { "weight": "1" }] }, { "featureType": "transit.station.bus", "elementType": "labels.icon", "stylers": [{ "saturation": "-100" }, { "weight": "1" }, { "lightness": "0" }] }, { "featureType": "transit.station.rail", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "transit.station.rail", "elementType": "labels.text.fill", "stylers": [{ "gamma": "1" }, { "lightness": "40" }] }, { "featureType": "transit.station.rail", "elementType": "labels.icon", "stylers": [{ "saturation": "-100" }, { "lightness": "30" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#d2d2d2" }, { "visibility": "on" }] }]
		});

		var imageUrl = require('../images/pointer.png');
		var $body = $('body');
		if ($body.hasClass('yellow')) {
			imageUrl = require('../images/pointer-yellow.png');
		} else if ($body.hasClass('blue')) {
			imageUrl = require('../images/pointer-blue.png');
		} else if ($body.hasClass('green')) {
			imageUrl = require('../images/pointer-green.png');
		}

		var image = {
			url: imageUrl,
			scaledSize: new google.maps.Size(60, 75),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(30, 75)
		};

		new google.maps.Marker({
			position: myLatLng,
			map: map,
			icon: image
		});
	});

	// Home slider
	$('.news-slider').each(function () {
		var element = $(this);
		var slides = element.find('.news-slider__item');

		function newsSlider() {
			var active = element.find('.active');
			var next = active.next('.news-slider__item');

			if (!next.length) {
				next = $(slides[0]);
			}

			active.removeClass('active');
			next.addClass('active');

			setTimeout(newsSlider, 4500);
		}
		slides.first().addClass('active');
		setTimeout(newsSlider, 4500);
	});

	$('.news-overview').each(async function () {
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/jquery.waypoints.js');
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/shortcuts/infinite.js');

		var element = $(this);
		var moreToShow = element.data('more-to-show');
		var nextUrl = element.data('next-url');
		var buttonText = element.data('button-text');

		if (moreToShow) {
			var button = $('<div class="button__wrapper -margin"><a class="button" rel="next" href="' + nextUrl + '">' + buttonText + '</a><span></span></div>');
			button.on('mouseenter', function (e) {
				var parentOffset = $(this).offset(),
					relX = e.pageX - parentOffset.left,
					relY = e.pageY - parentOffset.top;

				$(this).find('span').css({
					top: relY,
					left: relX
				});
			}).on('mouseout', function (e) {
				var parentOffset = $(this).offset(),
					relX = e.pageX - parentOffset.left,
					relY = e.pageY - parentOffset.top;

				$(this).find('span').css({
					top: relY,
					left: relX
				});
			});

			element.find('.last-content-block').append(button);

			element.find('a[rel=next]').one('click', function (e) {
				new Waypoint.Infinite({
					element: element,
					container: element.find('.last-content-block'),
					items: '.content-block',
					more: 'a[rel=next]',
					offset: function () {
						return Waypoint.offsetAliases['bottom-in-view'].call(this) + 200;
					},
					onAfterPageLoad: function (items) {
						// Fade in added items
						const delay = 40;
						items.css('opacity', 0).each(function (i) {
							var item = $(this);
							setTimeout(function () {
								item.css({
									opacity: 1,
									transition: 'opacity ease 120ms'
								});
							}, i * delay);
						});
					}
				});

				element.find('.button__wrapper.-margin').hide();
				e.preventDefault();
			});
		}
	});

	// Responsive menu
	$('.toggler').each(function () {
		$(this).click(toggleMenu);
	});

	function toggleMenu() {
		var toggler = $('.toggler');
		var responsiveNav = $('.responsive-nav');

		$('html').toggleClass('menu-open');
		responsiveNav.toggleClass('-collapsed');
		toggler.toggleClass('is-active');
	}

	// Lightbox
	$('body:has([rel=lightbox])').each(async function () {
		await import(/* webpackChunkName: "lightgallery" */ 'lightgallery');
		await import(/* webpackChunkName: "lightgallery" */ 'lg-video');

		$(this).lightGallery({
			selector: '[rel=lightbox]',
			download: false,
			thumbnail: false,
			fullScreen: false,
			actualSize: false,
			hash: false
		});
	});

	// Responsive menu
	$('.languages__current').each(function () {
		$(this).click(function () {
			$(this).next().toggleClass('-open');
		});
	});

	// Button hover effect
	var isTouch = 'ontouchstart' in window;
	$('.button__wrapper, .agenda-item__wrapper').on(isTouch ? 'touchstart' : 'mouseenter', function (e) {
		var parentOffset = $(this).offset(),
			relX = e.pageX - parentOffset.left,
			relY = e.pageY - parentOffset.top;

		$(this).find('span').css({
			top: relY,
			left: relX
		});
	}).on(isTouch ? 'touchend' : 'mouseleave', function (e) {
		var parentOffset = $(this).offset(),
			relX = e.pageX - parentOffset.left,
			relY = e.pageY - parentOffset.top;

		$(this).find('span').css({
			top: relY,
			left: relX
		});
	});

	// Jump to submitted form
	$('.umbraco-forms-form:has(form)').each(function () {
		var $this = $(this),
			$form = $this.find('form'),
			anchor = $this.find('.anchor').attr('name') || $this.attr('id');

		if (anchor) {
			$form.attr('action', $form.attr('action') + '#' + anchor);
		}
	});

	// Smooth scroll
	$('a[href*=\\#]').click(function () {
		var target = $(this.hash);

		if (!target.length) {
			target = $('[name=' + this.hash.slice(1) + ']');
		}

		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 500);

			return false;
		}
	});

	// Aside
	$('.aside').each(async function () {
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/jquery.waypoints.js');
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/shortcuts/sticky.js');
		await import(/* webpackChunkName: "waypoints" */ 'waypoints/lib/shortcuts/inview.js');

		var aside = $(this);

		/* Fix for adding offset to inview */
		Waypoint.Inview.prototype.createWaypoints = function () {
			// same as jQuery.outerHeight() function, works for IE9+
			function outerHeight(el) {
				var height = el.offsetHeight;
				var style = getComputedStyle(el);

				height += parseInt(style.marginTop) + parseInt(style.marginBottom);
				return height;
			}

			var configs = {
				vertical: [{
					down: 'enter',
					up: 'exited',
					offset: function () {
						var _offset = this.options.offset && this.options.offset.bottom || 0;
						return this.options.context.innerHeight - _offset;
					}.bind(this)
				}, {
					down: 'entered',
					up: 'exit',
					offset: function () {
						var _offset = this.options.offset && this.options.offset.bottom || 0;
						return this.options.context.innerHeight - outerHeight(this.element) - _offset;
					}.bind(this)
				}, {
					down: 'exit',
					up: 'entered',
					offset: function () {
						var _offset = this.options.offset && this.options.offset.top || 0;
						return _offset;
					}.bind(this)
				}, {
					down: 'exited',
					up: 'enter',
					offset: function () {
						var _offset = this.options.offset && this.options.offset.top || 0;
						return _offset - outerHeight(this.element);
					}.bind(this)
				}],
				horizontal: [{
					right: 'enter',
					left: 'exited',
					offset: '100%'
				}, {
					right: 'entered',
					left: 'exit',
					offset: 'right-in-view'
				}, {
					right: 'exit',
					left: 'entered',
					offset: 0
				}, {
					right: 'exited',
					left: 'enter',
					offset: function () {
						return -this.adapter.outerWidth();
					}
				}]
			};

			for (var i = 0, end = configs[this.axis].length; i < end; i++) {
				var config = configs[this.axis][i];
				this.createWaypoint(config);
			}
		};

		var sticky = new Waypoint.Sticky({
			element: aside[0]
		});

		var anchorLinks = aside.find('.aside__link');
		var firstLink = anchorLinks.first();
		var activeLink = firstLink;
		firstLink.addClass('active');

		anchorLinks.each(function () {
			var link = $(this);
			var section = $('section[data-anchor="' + link.data('name') + '"]');

			if (section.length) {
				var inview = new Waypoint.Inview({
					element: section[0],
					offset: {
						top: 100,
						bottom: 0
					},
					exit: function (direction) {
						if (direction === "down") {
							if (activeLink !== null) {
								activeLink.removeClass('active');
							}

							link.addClass('active');
							activeLink = link;
						}
					},
					enter: function (direction) {
						if (direction === "up") {
							if (activeLink !== null) {
								activeLink.removeClass('active');
							}

							link.addClass('active');
							activeLink = link;
						}
					}
				});
			}
		});
	});

	// Toastr
	$.getJSON('/umbraco/surface/Agenda/GetToastr', async function (response) {
		var toastr = (await import('toastr')).default;
		var Cookies = (await import('js-cookie')).default;

		if (response) {
			var cookieName = 'toast',
				ignoredIds = Cookies.get(cookieName),
				ignoreId = function (id) {
					if (ignoredIds) ignoredIds += ',' + id;
					else ignoredIds = id;

					Cookies.set(cookieName, ignoredIds);
				};

			if (!ignoredIds || !ignoredIds.includes(response.id)) {
				// Set options
				toastr.options = {
					progressBar: true,
					closeButton: true,
					timeOut: 5000,
					extendedTimeOut: 5000,
					showDuration: 0,
					target: 'header',
					iconClasses: {
						info: 'agenda-item'
					},
					titleClass: 'agenda-item__title',
					messageClass: 'agenda-item__date'
				};

				toastr.info('', '<strong>' + response.title + '</strong> - ' + response.shortDescription + ' - <span>' + response.date + '</span>', {
					onHidden: function () {
						// Add id to cookie
						ignoreId(response.id);
					}
				}).on({
					click: function () {
						// Add id to cookie and go to URL
						ignoreId(response.id);
						document.location = response.url;
					}
				});
			}
		}
	});
});